import React from 'react';
import Modal from './Modal';
import { Info, AlertCircle, CheckCircle, XCircle } from 'lucide-react';

export interface InfoDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  type?: 'info' | 'success' | 'warning' | 'error';
  okText?: string;
}

const InfoDialog: React.FC<InfoDialogProps> = ({
  isOpen,
  onClose,
  title,
  message,
  type = 'info',
  okText = 'OK'
}) => {
  const getTypeStyles = () => {
    switch (type) {
      case 'success':
        return {
          icon: CheckCircle,
          iconColor: 'text-[#4ade80]',
          bg: 'bg-[#173322]',
          button: 'bg-[#4ade80] hover:bg-[#6ee7a0]'
        };
      case 'warning':
        return {
          icon: AlertCircle,
          iconColor: 'text-[#f0b64c]',
          bg: 'bg-[#332711]',
          button: 'bg-[#f0b64c] hover:bg-[#f5c876]'
        };
      case 'error':
        return {
          icon: XCircle,
          iconColor: 'text-[#f38b83]',
          bg: 'bg-[#341a17]',
          button: 'bg-[#f38b83] hover:bg-[#f7aca6]'
        };
      case 'info':
      default:
        return {
          icon: Info,
          iconColor: 'text-[#60a5fa]',
          bg: 'bg-[#16212b]',
          button: 'bg-[#60a5fa] hover:bg-[#93c5fd]'
        };
    }
  };

  const styles = getTypeStyles();
  const IconComponent = styles.icon;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm" showCloseButton={false}>
      <div className="text-center">
        {/* Icon */}
        <div className={`mx-auto flex items-center justify-center w-12 h-12 rounded-full ${styles.bg} mb-4`}>
          <IconComponent className={`w-6 h-6 ${styles.iconColor}`} />
        </div>

        {/* Title */}
        <h3 className="text-lg font-semibold text-[#f3ede2] mb-2">
          {title}
        </h3>

        {/* Message */}
        <div className="text-[#b9ad9b] mb-6 whitespace-pre-line">
          {message}
        </div>

        {/* Action */}
        <div className="flex justify-center">
          <button
            onClick={onClose}
            className={`px-6 py-2 text-white rounded-lg transition-colors ${styles.button}`}
          >
            {okText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default InfoDialog;